import {Alert, Stack} from "react-bootstrap"

/**
 * Shows the status of directory account verification
 * @param {Object} props
 * @param {boolean|undefined} props.isAccountInDirectory - Account verification status
 */
export const DirectoryStatusAlert = ({isAccountInDirectory}) => {
    if (isAccountInDirectory === undefined) return null

    return isAccountInDirectory ? (
        <Alert className="mb-0" variant="primary" role="alert" aria-live="polite">
            <Stack direction="horizontal" gap={6} className="align-items-center">
                <i className="bi bi-check-circle-fill text-primary fs-2" />
                <div>
                    <Alert.Heading className="text-black-50">Active Directory account active. </Alert.Heading>
                    <span className="text-black-50"> Account details have been populated.</span>
                </div>
            </Stack>
        </Alert>
    ) : (
        <Alert variant="danger" className="align-items-center mb-0" role="alert" aria-live="polite">
            <Stack direction="horizontal" gap={6}>
                <i className="bi bi-exclamation-circle-fill fs-2 text-danger" />
                <div>
                    <Alert.Heading>Active Directory account cannot be found.</Alert.Heading>
                    <span> Try again or contact admin.</span>
                </div>
            </Stack>
        </Alert>
    )
}
